import camelCase from 'lodash/camelCase'
import capitalize from 'lodash/capitalize'
import { startOfToday, subDays, format } from 'date-fns'

export type DateRangeOption =
  | 'last7Days'
  | 'last30Days'
  | 'last60Days'
  | 'last90Days'
  | 'custom'

export type Range = {
  startDate: Date
  endDate: Date
}

export const DEFAULT_DATERANGE_FORMAT = 'yyyy-MM-dd'
const DATERANGE_FORMAT_OF_SELECTED_DATERANGE_STRING = 'dd MMM yy'

export const getDefaultDateRange = (range: DateRangeOption = 'last7Days') => {
  const daysMap: { [key in DateRangeOption]?: number } = {
    last7Days: 7,
    last30Days: 30,
    last60Days: 60,
    last90Days: 90,
  }

  const days = daysMap[range] || 7
  return {
    startDate: subDays(startOfToday(), days),
    endDate: startOfToday(),
  }
}

export const formatSelectedDateRange = (range: {
  startDate: Date
  endDate: Date
}) => {
  return `${format(
    range.startDate,
    DATERANGE_FORMAT_OF_SELECTED_DATERANGE_STRING,
  )} - ${format(range.endDate, DATERANGE_FORMAT_OF_SELECTED_DATERANGE_STRING)}`
}

export const dateRangeOptions = [
  'Last 7 days',
  'Last 30 days',
  'Last 60 days',
  'Last 90 days',
  'Custom',
].map((option) => ({
  value: camelCase(option),
  label: capitalize(option),
}))
